import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ppt_cart') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('ppt_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product) => {
    setItems(prev => {
      const exists = prev.find(i => i.uuid === product.uuid);
      if (exists) return prev; // pawn shop items are unique — no qty increase
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  const removeItem = (uuid) => setItems(prev => prev.filter(i => i.uuid !== uuid));

  const clearCart = () => setItems([]);

  const count = items.length;
  const subtotal = items.reduce((s, i) => s + i.price, 0);
  const hasFirearms = items.some(i => i.is_firearm);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, count, subtotal, hasFirearms }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
